import {
  getWindowScroll
} from "./chunk-4JXY2WW4.js";

// src/dom/get-element-offset/get-element-offset.ts
var getElementScroll = (el, axis = "both") => {
  if (axis === "both") {
    return { x: el.scrollLeft, y: el.scrollTop };
  }
  return axis === "x" ? el.scrollLeft : el.scrollTop;
};
var getElementOffset = (el, axis = "both", parent = window) => {
  const parentRect = parent === window || parent === null ? { top: 0, left: 0 } : parent.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();
  const top = elRect.top - parentRect.top;
  const left = elRect.left - parentRect.left;
  const scroll = parent === window || !parent ? getWindowScroll(axis) : getElementScroll(parent, axis);
  if (axis === "y")
    return top + scroll;
  if (axis === "x")
    return left + scroll;
  return {
    // @ts-expect-error -- TODO
    x: left + scroll.x,
    // @ts-expect-error -- TODO
    y: top + scroll.y
  };
};

export {
  getElementOffset
};
